import { useState, useEffect } from 'react';
import { useData } from '../context/DataContext';
import { updateContent } from '../api/api';
import AdminLayout from './AdminLayout';
import './Admin.css';

export default function AdminContent({ onLogout }) {
  const { content, refreshData } = useData();
  const [formData, setFormData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const token = localStorage.getItem('adminToken');

  useEffect(() => {
    if (content) {
      setFormData(content);
    }
  }, [content]);

  const handleChange = (section, field, value, index = null) => {
    setFormData(prev => {
      const newData = { ...prev };
      if (index !== null && Array.isArray(newData[section][field])) {
        newData[section][field][index] = value;
      } else {
        newData[section][field] = value;
      }
      return newData;
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');
    try {
      await updateContent(formData, token);
      await refreshData();
      setMessage('Content updated successfully!');
      setTimeout(() => setMessage(''), 3000);
    } catch (error) {
      setMessage('Failed to update content: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  if (!formData) {
    return (
      <AdminLayout onLogout={onLogout}>
        <div>Loading...</div>
      </AdminLayout>
    );
  }

  return (
    <AdminLayout onLogout={onLogout}>
      <div className="admin-header">
        <h1>Content Management</h1>
        <p>Edit homepage and static content</p>
      </div>

      {message && (
        <div className={message.includes('success') ? 'success-message' : 'error-message'}>
          {message}
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <div className="data-table" style={{ marginBottom: '2rem' }}>
          <div style={{ padding: '2rem' }}>
            <h2>Hero Section</h2>
            <div className="form-group">
              <label>Eyebrow Text</label>
              <input
                type="text"
                value={formData.hero.eyebrow}
                onChange={(e) => handleChange('hero', 'eyebrow', e.target.value)}
              />
            </div>
            <div className="form-group">
              <label>Title (use &lt;em&gt; for emphasis)</label>
              <input
                type="text"
                value={formData.hero.title}
                onChange={(e) => handleChange('hero', 'title', e.target.value)}
              />
            </div>
            <div className="form-group">
              <label>Subtitle</label>
              <textarea
                rows="3"
                value={formData.hero.subtitle}
                onChange={(e) => handleChange('hero', 'subtitle', e.target.value)}
              />
            </div>
          </div>
        </div>

        <div className="data-table" style={{ marginBottom: '2rem' }}>
          <div style={{ padding: '2rem' }}>
            <h2>About Section</h2>
            <div className="form-group">
              <label>Vision</label>
              <textarea
                rows="3"
                value={formData.about.vision}
                onChange={(e) => handleChange('about', 'vision', e.target.value)}
              />
            </div>
            <div className="form-group">
              <label>Mission</label>
              <textarea
                rows="3"
                value={formData.about.mission}
                onChange={(e) => handleChange('about', 'mission', e.target.value)}
              />
            </div>
            <div className="form-group">
              <label>Description Paragraph 1</label>
              <textarea
                rows="3"
                value={formData.about.description[0]}
                onChange={(e) => handleChange('about', 'description', e.target.value, 0)}
              />
            </div>
            <div className="form-group">
              <label>Description Paragraph 2</label>
              <textarea
                rows="3"
                value={formData.about.description[1]}
                onChange={(e) => handleChange('about', 'description', e.target.value, 1)}
              />
            </div>
            <div className="form-group">
              <label>Description Paragraph 3</label>
              <textarea
                rows="3"
                value={formData.about.description[2]}
                onChange={(e) => handleChange('about', 'description', e.target.value, 2)}
              />
            </div>
          </div>
        </div>

        <div className="data-table" style={{ marginBottom: '2rem' }}>
          <div style={{ padding: '2rem' }}>
            <h2>Contact Information</h2>
            <div className="form-group">
              <label>Email</label>
              <input
                type="email"
                value={formData.contact.email}
                onChange={(e) => handleChange('contact', 'email', e.target.value)}
              />
            </div>
            <div className="form-group">
              <label>Sales Email</label>
              <input
                type="email"
                value={formData.contact.salesEmail}
                onChange={(e) => handleChange('contact', 'salesEmail', e.target.value)}
              />
            </div>
            <div className="form-group">
              <label>Phone</label>
              <input
                type="tel"
                value={formData.contact.phone}
                onChange={(e) => handleChange('contact', 'phone', e.target.value)}
              />
            </div>
            <div className="form-group">
              <label>Address Line 1</label>
              <input
                type="text"
                value={formData.contact.address.line1}
                onChange={(e) => {
                  setFormData(prev => ({
                    ...prev,
                    contact: {
                      ...prev.contact,
                      address: { ...prev.contact.address, line1: e.target.value }
                    }
                  }));
                }}
              />
            </div>
            <div className="form-group">
              <label>Address Line 2</label>
              <input
                type="text"
                value={formData.contact.address.line2}
                onChange={(e) => {
                  setFormData(prev => ({
                    ...prev,
                    contact: {
                      ...prev.contact,
                      address: { ...prev.contact.address, line2: e.target.value }
                    }
                  }));
                }}
              />
            </div>
            <div className="form-group">
              <label>Country</label>
              <input
                type="text"
                value={formData.contact.address.country}
                onChange={(e) => {
                  setFormData(prev => ({
                    ...prev,
                    contact: {
                      ...prev.contact,
                      address: { ...prev.contact.address, country: e.target.value }
                    }
                  }));
                }}
              />
            </div>
          </div>
        </div>

        <button type="submit" className="btn-primary" disabled={loading}>
          {loading ? 'Saving...' : 'Save All Changes'}
        </button>
      </form>
    </AdminLayout>
  );
}
